export const TITLE_MAP: Record<string, string> = {
  card: 'Номер карты',
  card_type: 'Тип карты',
  phone: 'Вывод на телефон',
  account: 'Аккаунт',
};

export const STATUS_OPTIONS = [
  { label: 'created', value: 'Создано' },
  { label: 'processing', value: 'В процессе' },
  { label: 'success', value: 'Успешно обработана' },
  { label: 'error', value: 'Ошибка операции' },
  { label: 'other', value: 'Другой статус' },
];

export const AMOUNT_TYPES = [
  { label: 'amount_gt=0', value: 'Пополнение' },
  { label: 'amount_lt=0', value: 'Снятие' },
];

export const OPERATION_TYPES = [
  { label: 'activity', value: 'activity' },
  { label: 'competition', value: 'competition' },
  { label: 'activity_b2c', value: 'activity_b2c' },
  { label: 'kassa24', value: 'kassa24' },
  { label: 'mbank', value: 'mbank' },
  { label: 'oson', value: 'oson' },
  { label: 'yurta', value: 'yurta' },
  { label: 'expiration', value: 'expiration' },
  { label: 'system', value: 'system' },
];
